import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { isApiError } from './api-client';

/**
 * Puts the field problems returned by the API next to the matching inputs.
 * Returns true when at least one field got a message (no need for a toast then).
 */
export function applyServerErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
): boolean {
  if (!isApiError(error)) return false;
  let applied = false;
  for (const issue of error.fieldIssues) {
    if (!issue.path) continue;
    setError(issue.path as Path<T>, { type: 'server', message: issue.message });
    applied = true;
  }
  return applied;
}
